export function validateCPF(cpf: string): boolean {
	if (!cpf) return false

	cpf = cpf.replace(/\D/g, '')

	if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false

	const calcCheckDigit = (cpf: string, factor: number) => {
		let total = 0
		for (let i = 0; i < factor - 1; i++) {
			total += parseInt(cpf[i]) * (factor - i)
		}
		const remainder = (total * 10) % 11
		return remainder === 10 ? 0 : remainder
	}

	const digit1 = calcCheckDigit(cpf, 10)
	const digit2 = calcCheckDigit(cpf, 11)

	return digit1 === parseInt(cpf[9]) && digit2 === parseInt(cpf[10])
}
